import Model from "./base/model";

class BillingExtraPlanValue extends Model{
  resourceName() {
    return "billing_extra_plan_values";
  }

  fields() {
    return {
      quantity: "",
      price: "",
      extra_plan_name: "",
    }
  }
}

export default new BillingExtraPlanValue();
